import React from 'react'
import { initialValuesTypes } from '../../pages/index/indexDefaultComponent'
import { FormikProps, FormikValues } from 'formik'
import { useTranslation } from 'react-i18next'

interface Props {
    form: FormikProps<FormikValues>
    setShowMoreFilters: React.Dispatch<boolean>
    initialValues: initialValuesTypes
    initialValuesClone: initialValuesTypes
}

const FiltersBlock: React.FunctionComponent<Props> = ({
    form,
    setShowMoreFilters,
    initialValues,
    initialValuesClone
}: Props) => {
    const [t] = useTranslation()

    interface indexFiltersType {
        title: string
        values: string[]
        isChosen: boolean
    }

    const indexFilters: indexFiltersType[] = [
        {
            title: t('period'),
            // values: [t('Last year')],
            values: [t('All time')],
            isChosen: false
        },
        {
            title: t('material'),
            values: [t('Photo and Video'), t('Only photo'), t('Only video')],
            isChosen: false
        },
        {
            title: t('gender'),
            values: [t('Females and males'), t('Females or couples'), t('Males only')],
            isChosen: false
        },
        {
            title: t('certified'),
            values: [t('Certified and non-certified'), t('Only Certified')],
            isChosen: false
        },
        {
            title: t('free'),
            values: [t('All content'), t('Only Free')],
            isChosen: false
        }
    ]

    return (
        <div className="filters">
            {indexFilters.map((item) => (
                <div
                    key={item.title}
                    onClick={() => {
                        if (initialValuesClone[item.title] === 0) {
                            setShowMoreFilters(true)
                            return
                        }
                        if (initialValuesClone[item.title]) {
                            if (item.title === 'period') {
                                form.setFieldValue('dateFrom', initialValues.dateFrom)
                                form.setFieldValue('dateTo', initialValues.dateTo)
                                form.setFieldValue('periodToSend', initialValues.periodToSend)
                            }
                            form.setFieldValue(item.title, 0)
                            form.submitForm()
                        }
                    }}
                    className={initialValuesClone[item.title] !== 0 ? 'filter_index chosen' : 'filter_index'}
                >
                    {item.values[initialValuesClone[item.title]] || initialValuesClone.periodToSend}
                </div>
            ))}
        </div>
    )
}

export default FiltersBlock
